import "core-js/modules/es.error.cause.js";
export default {
  // name: 'Aliyu/nCaptcha',
  props: {
    sceneId: {
      type: String,
      default: process.env.VUE_APP_ALICAPTCHA_SCENEID
    },
    prefix: {
      type: String,
      default: process.env.VUE_APP_ALICAPTCHA_PREFIX
    },
    // 滑块宽度
    slideWidth: {
      type: Number,
      default: 320
    },
    // 滑块高度
    slideHeight: {
      type: Number,
      default: 40
    },
    // 语言
    language: {
      type: String,
      default: 'cn'
    },
    // 模式：embed(嵌入式) / popup(弹出式)
    mode: {
      type: String,
      default: 'embed',
      validator: val => ['embed', 'popup'].includes(val)
    },
    // 验证函数，由父组件传入，需返回 Promise<{ captchaResult: boolean, bizResult: boolean }>
    verifyHandler: {
      type: Function,
      default: null
    },
    rem: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      captcha: null,
      error: null,
      isReady: false
    };
  },
  computed: {
    // 计算实际滑块宽度，确保不超出屏幕
    computedWidth() {
      return Math.min(this.slideWidth, window.innerWidth - 40);
    }
  },
  mounted() {
    this.initCaptcha();
  },
  beforeUnmount() {
    this.destroyCaptcha();
  },
  methods: {
    /**
     * 初始化验证码
     */
    initCaptcha() {
      this.error = null;

      // 检查验证码库是否已加载
      if (typeof window.initAliyunCaptcha !== 'function') {
        this.error = '验证码库未加载';
        this.$emit('error', new Error('阿里云验证码库未加载，请检查 script 标签'));
        return;
      }
      window.initAliyunCaptcha({
        SceneId: this.sceneId,
        prefix: this.prefix,
        mode: this.mode,
        element: '#captcha-element',
        button: '#captcha-button',
        slideStyle: {
          width: this.computedWidth,
          height: this.slideHeight
        },
        autoRefresh: false,
        language: this.language,
        // 嵌入式模式需要设置 immediate: true
        immediate: this.mode === 'embed',
        rem: this.rem,
        // 获取实例回调
        getInstance: instance => {
          this.captcha = instance;
          console.log('=  this.captcha  this.captcha  this.captcha>', this.captcha);
          this.isReady = true;
          this.$emit('ready', instance);

          // 嵌入式模式下自动显示
          if (this.mode === 'embed') {
            this.$nextTick(() => {
              this.show();
            });
          }
        },
        // 验证回调
        captchaVerifyCallback: async captchaVerifyParam => {
          try {
            // 如果父组件传入了验证函数，则调用它
            if (this.verifyHandler) {
              var _result$captchaResult, _result$bizResult;
              const result = await this.verifyHandler(captchaVerifyParam);
              return {
                captchaResult: (_result$captchaResult = result === null || result === void 0 ? void 0 : result.captchaResult) !== null && _result$captchaResult !== void 0 ? _result$captchaResult : false,
                bizResult: (_result$bizResult = result === null || result === void 0 ? void 0 : result.bizResult) !== null && _result$bizResult !== void 0 ? _result$bizResult : false
              };
            }

            // 默认行为：仅验证验证码通过，业务验证交给父组件处理
            // 阿里云验证码v1 需要的参数， v2版本做兼容，替换字端
            this.$emit('slideSuccessCallback', {
              sessionId: this.sceneId,
              sig: captchaVerifyParam,
              token: ''
            });
            return {
              captchaResult: true,
              bizResult: true
            };
          } catch (error) {
            this.$emit('error', error);
            debugger;
            this.$emit('slideErrorCallback');
            return {
              captchaResult: false,
              bizResult: false
            };
          }
        },
        // 业务验证成功回调
        onBizResultCallback: () => {
          // this.$emit('success')
        }
      });
    },
    /**
     * 显示验证码
     */
    show() {
      var _this$captcha;
      if ((_this$captcha = this.captcha) !== null && _this$captcha !== void 0 && _this$captcha.show) {
        try {
          this.captcha.show();
        } catch (e) {
          debugger;
          this.$emit('slideErrorCallback');
        }
      }
    },
    /**
     * 隐藏验证码
     */
    hide() {
      var _this$captcha2;
      if ((_this$captcha2 = this.captcha) !== null && _this$captcha2 !== void 0 && _this$captcha2.hide) {
        try {
          this.captcha.hide();
        } catch (e) {
          // ignore
        }
      }
    },
    /**
     * 重置/刷新验证码
     * 注意：阿里云验证码 V2 架构使用 refresh() 方法，无痕形态不支持此方法
     */
    reset() {
      var _this$captcha3;
      if ((_this$captcha3 = this.captcha) !== null && _this$captcha3 !== void 0 && _this$captcha3.refresh) {
        try {
          this.captcha.refresh();
        } catch (e) {
          console.warn('验证码刷新失败:', e);
        }
      }
    },
    /**
     * 销毁验证码
     */
    destroyCaptcha() {
      // 清理阿里云验证码可能遗留的DOM元素
      const mask = document.getElementById('aliyunCaptcha-mask');
      const popup = document.getElementById('aliyunCaptcha-window-popup');
      mask === null || mask === void 0 ? void 0 : mask.remove();
      popup === null || popup === void 0 ? void 0 : popup.remove();
      this.captcha = null;
      this.isReady = false;
    },
    /**
     * 获取验证码实例（供父组件调用）
     */
    getInstance() {
      return this.captcha;
    }
  }
};